import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Wrapper chroniący trasy wymagające autentykacji.
 * @param {object} props
 * @param {React.ReactNode} props.children - Komponent do renderowania
 * @param {string[]} [props.allowedRoles] - Opcjonalna lista dozwolonych ról (np. ['COACH', 'SPORTS_CLUB'])
 */
function ProtectedRoute({ children, allowedRoles }) {
  const { isAuthenticated, userType, teams } = useAuth();
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userType)) {
    return <Navigate to="/" replace />;
  }

  // Coach bez zdefiniowanych okresów przygotowawczych — wymuś przekierowanie na /settings
  const needsPreseasonSetup = userType === 'COACH' && teams?.length > 0 && !teams.some(t => t.isPreseasonDefined);
  if (needsPreseasonSetup && location.pathname !== '/settings') {
    return <Navigate to="/settings" replace />;
  }

  return children;
}

export default ProtectedRoute;
